import axios from 'axios'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
import { find, findAll } from "../utils/dom";

function maskTelBR(input) {
	input.addEventListener('input', () => {
		let v = input.value.replace(/\D/g, '').slice(0, 11);
		if (v.length > 10) {
			// Celular: (99) 9 9999-9999
			v = v.replace(/^(\d{2})(\d{1})(\d{4})(\d{0,4}).*/, '($1) $2 $3-$4');
		} else if (v.length > 6) {
			// Fixo: (99) 9999-9999
			v = v.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
		} else if (v.length > 2) {
			v = v.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
		} else if (v.length > 0) {
			v = v.replace(/^(\d{0,2})/, '($1');
		}
		input.value = v;
	});

	input.addEventListener('keydown', (e) => {
		// Permite: backspace, delete, tab, setas
		if ([8, 46, 9, 37, 39].includes(e.keyCode)) return;
		// Bloqueia qualquer tecla que não seja número
		if (!/^\d$/.test(e.key)) e.preventDefault();
	});
}

const Newsletter = () =>{
	const modalNewsLetter = findAll(`[js-modal="newsletters"]`);
	if(!modalNewsLetter) return;

	// Aplica máscara a todos os inputs de tel do newsletter
	findAll(`#newsletters-tel`)?.forEach(maskTelBR);

	const showToastify = (message, opts) => {
		Toastify({
			duration: 3000,
			position: "center",
			style: { background: "rgba(193, 255, 129)", fontSize: "18px", color: "rgba(45, 71, 120, 1)" },
			text: message,
			...opts
		}).showToast();
	}


	const $ = {
		form: findAll(`[js-form="newsletters"]`)
	}


	$.form?.forEach((form_item)=>{
		form_item?.addEventListener("submit", (e) =>{
			e.preventDefault();

			const form = new FormData(e.target);
			const buttonSubmit = e.target.querySelectorAll(`button[type='submit']`);

			disabledBtn(buttonSubmit);

			const form_data = {
				email: form.get('newsletters-email'),
				tel: form.get('newsletters-tel'),
			}

			const url = "/newsletter/"
			axios.post(url, form_data)
				.then((response) => showMessage(response, buttonSubmit, e.target))
				.catch((response) => showMessage(response, buttonSubmit, e.target));

		})
	})


	function showMessage(response, btnFormContato, form) {
		const isSuccess = response.data && response.data.message;
		const message = response.data ? response.data.message : response.message;

		const backgroundColor = isSuccess ? "rgba(193, 255, 129)" : "rgba(233, 44, 44)";
		const textColor = isSuccess ? "rgba(45, 71, 120, 1)" : "white";

		showToastify(message, {
			style: {
				background: backgroundColor,
				color: textColor,
				fontSize: "18px",
				borderRadius: "8px"
			},
		});
		form?.reset();
		setTimeout(() => enabledBtn(btnFormContato), 1000);
	}

	function disabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = true;
			btn.classList.add("disabled");
		})
	}

	function enabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = false;
			btn.classList.remove("disabled");
		})
	}


}

export default Newsletter;